export default __webpack_public_path__ + "static/media/10S.99cb26ab.svg";